<template>
  <div class="w-full px-4 pt-16">
    <div class="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
      <disclosure-list-group-item>
        <span>Signup for Free!</span>
        <template #right>
          Step 1
        </template>
        <template #expanded>
          Signup in 30 seconds with a simple email and password. No Credit card required.
        </template>
      </disclosure-list-group-item>

      <disclosure-list-group-item>
        Create a Fundraiser Campaign
        <span class="float-right"> Step 2 </span>
        <template #expanded>
          Give your fundraiser a name, goal, deadline, description, and style it with some images and video to personalize it. You can enable group fundraising or keep it as a simple standalone crowd fundraising page.
        </template>
      </disclosure-list-group-item>

      <disclosure-list-group-item>
        Invite Group Members
        <span class="float-right"> Step 3 </span>
        <template #expanded>
          Group members are invited to create personalized pages linked to your fundraising page. They each get their own unique page and can customize their fundraising page with their own story, images, and videos. All donations will go directly to your organization's bank account.
        </template>
      </disclosure-list-group-item>
      <disclosure-list-group-item>
        Spread the Word
        <span class="float-right"> Step 4 </span>
        <template #expanded>
          GroupRev comes with powerful features to help you spread the world and reach potential donors. Import emails for family and friends and send out personalize fundraising emails that get results. Download a QR code, share over text message, and integrate with social media. With GroupRev you have the power to promote your cause how you want.
        </template>
      </disclosure-list-group-item>
      <disclosure-list-group-item>
        Accept Donations
        <span class="float-right"> Step 4 </span>
        <template #expanded>
          Accept donations via credit card, apple pay, and more. Even if you collect checks, grants, cash, or offline donations, you can record them towards your fundraising total.
        </template>
      </disclosure-list-group-item>
      <disclosure-list-group-item>
        Withdraw Funds
        <span class="float-right"> Step 4 </span>
        <template #expanded>
          Donations are transferred to your bank account via direct deposit. Enjoy simple to use reporting to reconcile all your fundraising easily.
        </template>
      </disclosure-list-group-item>
    </div>
  </div>
</template>

<script setup>

import DisclosureListGroupItem from './disclosure-list-group-item.vue'
</script>
